import React from "react"

export const InputSelect = ({ className, label, value, children, onChange }) => {
  return <span className={className} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', margin: '0 0.75rem', marginBottom: '0.5rem' }}>
    <label className="active">{label}</label>
    <select
      onChange={e => onChange(e, e.target.value)}
      value={value}
      style={{ display: 'block' }}
    >
      {children}
    </select>
  </span>
}